import { apiGetBlob } from '@/shared/api'
import { zoneTag } from '@/shared/lib'
import type { ReportRange } from '../model/range'
import { REPORT_SLICE_PATH, type ReportSliceName, reportRangeQuery } from './queries'

const SLICE_TITLE: Record<ReportSliceName, string> = {
  employees: 'сотрудники',
  projects: 'проекты',
  companies: 'компании',
}

// Выгружает бэкенд: тот же путь, что у таблицы, отличается параметром формата —
// цифры в файле собраны тем же кодом, что и на экране.
export function fetchReportCsv(slice: ReportSliceName, range: ReportRange): Promise<Blob> {
  return apiGetBlob(REPORT_SLICE_PATH[slice], { ...reportRangeQuery(range), format: 'csv' })
}

// Зона в имени файла — не украшение: файл живёт дальше экрана, а его цифры
// зависят от того, по чьему календарю нарезаны сутки границ периода.
export function reportCsvFilename(slice: ReportSliceName, range: ReportRange): string {
  return `Отчёт — ${SLICE_TITLE[slice]} — ${range.from} — ${range.to} (сутки по зоне ${zoneTag()}).csv`
}
